import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IAdminRolesResponse } from '../interfaces/IAdminRolesResponse';

export async function fetchNewsRoles(): Promise<IAdminRolesResponse> {
  return apiGet<IAdminRolesResponse>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, true)}/admin/news/roles`);
}
